
import { Users } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { useTranslation } from 'react-i18next';

interface GenderFilterProps {
  selectedGenders: string[];
  onGenderChange: (genders: string[]) => void;
}

const GenderFilter = ({ selectedGenders, onGenderChange }: GenderFilterProps) => {
  const { t } = useTranslation('practitioners');

  const handleGenderToggle = (gender: string) => {
    let newGenders: string[];
    
    if (selectedGenders.includes(gender)) {
      // Uncheck - remove from array
      newGenders = selectedGenders.filter(g => g !== gender);
      // If none selected, select all
      if (newGenders.length === 0) {
        newGenders = ['male', 'female', 'other'];
      }
    } else {
      // Check - add to array
      newGenders = [...selectedGenders, gender];
    }
    
    onGenderChange(newGenders);
  };

  return (
    <div>
      <h3 className="text-sm font-semibold mb-3 flex items-center">
        <Users className="mr-2 h-4 w-4 text-amber-600" /> {t('genderFilter.title')}
      </h3>
      <div className="flex flex-wrap gap-4">
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="gender_male"
            checked={selectedGenders.includes('male')}
            onCheckedChange={() => handleGenderToggle('male')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="gender_male" className="text-sm font-medium cursor-pointer">
            {t('genderFilter.male')}
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="gender_female"
            checked={selectedGenders.includes('female')}
            onCheckedChange={() => handleGenderToggle('female')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="gender_female" className="text-sm font-medium cursor-pointer">
            {t('genderFilter.female')}
          </label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox 
            id="gender_other"
            checked={selectedGenders.includes('other')}
            onCheckedChange={() => handleGenderToggle('other')}
            className="bg-amber-50 border-amber-300 text-amber-600"
          />
          <label htmlFor="gender_other" className="text-sm font-medium cursor-pointer">
            {t('genderFilter.other')}
          </label>
        </div>
      </div>
    </div>
  );
};

export default GenderFilter;
